{
  "id": "campaign-074",
  "name": "Untamed Range",
  "seed": "campaign:74",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,,,,,,,,,",
    ",b,,b,,b,,,,",
    "...,,,,,,,,,",
    "....sooo,,,,",
    "...ssoFo#,,,",
    ".ssssooo,,,,",
    ".,,,..x,,,,,",
    ",~,,...,,,,,",
    "~~~,...,,,,,",
    ",~,,,,**,,,,",
    ",,,,,W**W,..",
    ",,,,W,,,,...",
    ",,,,,,,,,...",
    ",T,,T,,#,...",
    ",,,,,,,,,,..",
    ",,,,,,T,,T,,",
    ",#,,,,,,,,..",
    ",,,,,,,,...S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 3,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 8
    },
    {
      "kind": "rabbit",
      "x": 9,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 6
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 2,
      "y": 9
    },
    {
      "kind": "gas",
      "x": 9,
      "y": 14
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 13
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 2
    }
  ],
  "generatorVersion": 3,
  "level": 74,
  "biome": "golf",
  "par": {
    "reel": 18716,
    "push": 11268,
    "selfPropelled": 10443,
    "tractor": 5683,
    "zeroTurn": 7216,
    "fairway": 4333
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 7,
      "selfPropelled": 0,
      "tractor": 16,
      "zeroTurn": 21,
      "fairway": 1
    }
  }
}
